import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function ListPelunasanPinjamanTunai() {

  //Roles
  const USP = 3;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataPengajuan, setDataPengajuan] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataPengajuan = async () => {

    await baseAPI
      .get(`/v1/ajuanpinjam`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.belumlunas
        setDataPengajuan(data)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };


  useEffect(() => {
    setIsLoading(true);
    if (users.role === USP) {
      fetchDataPengajuan();
    }
  }, [token]);

  const contentTableAction = (id, iduser) => {
    if (id && iduser !== null) {
      return (
        <div className='text-center'>
          <Link 
            to={`/pinjamtunai/listpelunasanpinjamtunai/approvalpelunasanpinjam/${id}/${iduser}`} 
            className="badge badge-primary"
            style={{ backgroundColor: "#6A9C89", marginRight: 10 }}
          >
            <Icon name="Edit" size={16} />
          </Link>
          {/* <button 
            className="badge bg-danger"
            onClick={() => deleteAjuan(id)}
          >
            <Icon name="Trash" size={16} />
          </button> */}
        </div>
      )
    }
  };
  
  const ajuanPinjamListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'ID Kopkar',
        id: 'idkopkar',
        width: '8%',
        accessor: 'idkopkar',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.idkopkar}</div>
      },
      {
        Header: 'Nama',
        id: 'nama',
        width: '12%',
        accessor: 'nama',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.name_anggota}</div>
      },
      {
        Header: 'NPP',
        id: 'npp',
        width: '8%',
        accessor: 'npp',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.npp_anggota}</div>
      },
      {
        Header: 'Nomor Pinjaman',
        id: 'nopinjam',
        width: '8%',
        accessor: 'nopinjam',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.notrxdetailpinjam}</div>
      },
      {
        Header: 'Jangka',
        id: 'jangka',
        width: '8%',
        accessor: 'jangka',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.lama}</div>
      },
      {
        Header: 'Cicilan',
        id: 'cicilan',
        width: '8%',
        accessor: 'cicilan',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseInt(cellInfo.row.original.cpokok + cellInfo.row.original.jasa_bulan).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Plafond',
        id: 'plafond',
        width: '8%',
        accessor: 'plafond',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.plafond).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Tanggal Pinjam',
        id: 'tglpinjam',
        width: '8%',
        accessor: 'tglpinjam',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.trxdetailpinjam).format("DD/MM/yyyy")}</div>
      },
      {
        Header: 'Status',
        id: 'status',
        width: '8%',
        accessor: 'status',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.status}</div>
      },
      {
        Header: 'Action',
        id: 'action',
        width: '8%',
        Cell: (cellInfo) =>
          contentTableAction(
            cellInfo.row.original.id,
            cellInfo.row.original.id_users,
          )
      }
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Ajuan Pelunasan"
                columns={columns}
                data={dataPengajuan}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Data Pinjaman Tunai</Link> /{' '}
                <Link to='/pinjamtunai/listpelunasanpinjamtunai' style={{ color: '#333' }}>List Pelunasan Pinjaman Tunai</Link>
              </li>
            </ol>
          </div>

          {/* Download Report Data */}
          {/* <div className='col-auto ml-auto d-print-none'>
            <Link to="/employee/reportemployee">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('download report data')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Download" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Download Ajuan Pelunasan</span>
                </div>
              </button>
            </Link>
          </div> */}

        </div>
      </div>
    </>
  )
    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : ajuanPinjamListView()}

    </div>

  );

}

export default ListPelunasanPinjamanTunai;